import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { MODAL_TYPE } from 'Defaults/modals'

import {
  _WithLoginBlurBox,
  _BlurContainer,
  _AppBtn,
} from './styles'

class WithLoginBlurBox extends PureComponent {
  onOpenLogin() {
    this.props.openModal({ modalType: MODAL_TYPE.LOGIN })
  }
  onVerifyEmailClick() {
    this.props.openModal({ modalType: MODAL_TYPE.VERIFY_EMAIL })
  }
  render() {
    const {
      children, userEmailVerified, userIsAuthentificated,
      loginRequired, emailVerificationRequired, priceHistoryTable,
    } = this.props

    if(loginRequired && !userIsAuthentificated) {
      return (
        <_WithLoginBlurBox>
          <_BlurContainer>
            {children}
          </_BlurContainer>
          <_AppBtn
            primary
            medium
            onClick={this.onOpenLogin.bind(this)}
          >
            Sign up/Login to see details
          </_AppBtn>
        </_WithLoginBlurBox>
      )
    }

    if(priceHistoryTable && userIsAuthentificated && emailVerificationRequired && !userEmailVerified) {
      return (
        <_WithLoginBlurBox>
          {children}
          <_AppBtn
            primary
            medium
            onClick={this.onVerifyEmailClick.bind(this)}
          >
            Verify Your email to see details
          </_AppBtn>
        </_WithLoginBlurBox>
      )
    } if(userIsAuthentificated && emailVerificationRequired && !userEmailVerified) {
      return (
        <_WithLoginBlurBox>
          <_BlurContainer>
            {children}
          </_BlurContainer>
          <_AppBtn
            primary
            medium
            onClick={this.onVerifyEmailClick.bind(this)}
          >
            Verify Your email to see details
          </_AppBtn>
        </_WithLoginBlurBox>
      )
    }


    return children
  }
}

WithLoginBlurBox.propTypes = {
  userEmailVerified: PropTypes.number,
  userIsAuthentificated: PropTypes.bool,
  children: PropTypes.node,
  openModal: PropTypes.func,
  priceHistoryTable: PropTypes.bool,
  loginRequired: PropTypes.bool,
  emailVerificationRequired: PropTypes.bool,
}

export default WithLoginBlurBox

